import type { Group } from '../types'
import type { RenderExpandIconProps } from 'rc-table/lib/interface'

import { CaretDownOutlined, CaretRightOutlined } from '@ant-design/icons'
import classNames from 'classnames'

export function ExpandIcon(props: RenderExpandIconProps<Group>): JSX.Element | null {
  if (!props.expandable) {
    return null
  }

  return (
    <button
      className={classNames(
        '-ml-1 p-2 flex items-center justify-center transition-opacity translate-x-2',
        {
          'opacity-50 hover:opacity-75': !props.expanded,
          'opacity-100': props.expanded
        }
      )}
      onClick={e => {
        props.onExpand(props.record, e)
      }}
    >
      {props.expanded && <CaretDownOutlined />}

      {!props.expanded && <CaretRightOutlined />}
    </button>
  )
}
